var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9954 32.541H68.7956H61.5967H43.5995H36.4006H18.4034H11.2045H10.0047C8.02502 32.541 6.40527 34.2019 6.40527 36.2319V60.8376C6.40527 61.5142 6.94519 62.0678 7.60509 62.0678H16.0038C16.5437 62.0678 17.0116 61.6988 17.1556 61.1697L19.3033 53.4559H60.6968L62.8445 61.1697C62.9885 61.6988 63.4564 62.0678 63.9963 62.0678H72.395C73.0549 62.0678 73.5948 61.5142 73.5948 60.8376V36.2319C73.5948 34.2019 71.9751 32.541 69.9954 32.541Z",
    fill: "#CDA876"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.402 32.5435V27.6223C18.402 25.5924 20.0218 23.9315 22.0014 23.9315H32.7998C34.7795 23.9315 36.3992 25.5924 36.3992 27.6223V32.5435H43.5981V27.6223C43.5981 25.5924 45.2178 23.9315 47.1975 23.9315H57.9958C59.9755 23.9315 61.5953 25.5924 61.5953 27.6223V32.5435H66.3945H68.7942V9.16808C68.7942 8.49142 68.2542 7.93779 67.5944 7.93779H59.1957C58.5718 7.93779 58.0558 8.42991 57.9958 9.06965L57.7679 11.8993C47.4255 6.60908 32.5718 6.60908 22.2294 11.8993L22.0014 9.06965C21.9415 8.42991 21.4255 7.93779 20.8016 7.93779H12.4029C11.743 7.93779 11.2031 8.49142 11.2031 9.16808V32.5435H13.6028H18.402Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/frame_2.e845514198447673ee4707fc86af6c10.svg";
export { ForwardRef as ReactComponent };